import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NoticeItem } from '../../model/notice-item';

@Component({
    selector: 'notice-list',
    template: `
    <div *ngIf="data.list?.length === 0; else listTpl">
        <div class="not-found">
            <img *ngIf="data.emptyImage" src="{{data.emptyImage}}" alt="not found" />
            <p>{{data.emptyText}}</p>
        </div>
        <div class="operation">
            <div class="clear" style="cursor: not-allowed;color: #ccc;">全部标记已读</div>
            <div class="loadMore" (click)="onLoadData()">查看更多</div>
        </div>
    </div>
    <ng-template #listTpl>
        <nz-list [nzDataSource]="data.list" [nzRenderItem]="item">
            <ng-template #item let-item>
                <nz-list-item (click)="onSelect(item)">
                    <div nzOverlayClassName="notice-icon-popover-popover" nz-popover nzPlacement="left" nzTitle="{{item.title}}" nzContent="{{item.content}}" style="width: 100%;">
                        <nz-list-item-meta [nzTitle]="nzTitle" [nzDescription]="nzDescription" [nzAvatar]="item.logo">
                            <ng-template #nzTitle>
                                <span [ngStyle]="{'color':item.readOver ? '#ddd' : '' }">{{item.title}}</span>
                                <div class="extra" *ngIf="item.sendTime" [ngStyle]="{'color':item.readOver ? '#ddd' : '' }">{{item.sendTime}}</div>
                            </ng-template>
                            <ng-template #nzDescription>
                                <div *ngIf="item.content" class="description" [ngStyle]="{'color':item.readOver ? '#ddd' : '' }">{{item.content}}</div>
                            </ng-template>
                        </nz-list-item-meta>
                    </div>
                </nz-list-item>
            </ng-template>
        </nz-list>
        <div class="operation">
            <div class="clear" (click)="onClear()">全部标记已读</div>
            <div class="loadMore" (click)="onLoadData()">查看更多</div>
        </div>
    </ng-template>
    `
})
export class NoticeListComponent {
    @Input() data: NoticeItem;
    @Output() select = new EventEmitter<any>();
    @Output() clear = new EventEmitter<string>();
    @Output() loadData = new EventEmitter<any>();

    onSelect(item: any) {

        this.select.emit({
            title: this.data.title,
            item: item
        });
    }

    onClear() {
        this.clear.emit(this.data.title);
    }

    onLoadData() {
        this.loadData.emit(this.data);
    }
}
